export default __webpack_public_path__ + "static/plant-5fae2810d94380985ac2e956fce9e1cb.svg";